<template>
<div>
    <h3>{{$t('allergies')}}</h3>
    <b-row v-if="showZeroBox">
        <b-col cols="12">
            <base-checkbox v-model="zeroItems" @change="toggleZeroBox">
                <span v-html="$t('noMedAllergies')"></span>
            </base-checkbox>
        </b-col>
    </b-row>
    <base-card v-if="!zeroItems" overflowVisible @rightBtnClick="showAddSection = true" hideNeuCardClass :hideButtons="historyReadOnly" showRightBtn>
        <template v-if="!showAddSection" :slot="$uiHelpers.isMobile || $uiHelpers.isTablet ? 'append-btn-title' : 'right-button'">
            <add-button></add-button>
        </template>
        <div class="row mb-4" v-if="showAddSection">
            <div class="col-lg-6 col-12 p-1">
                <base-select @search="loadSelectOptions($event)" clearable searchable :loading="select.loading" :options="select.options" v-model="select.value" label="name" valueProp="id" :placeholder="$t('medication-ph')"></base-select>
            </div>
            <div class="col-lg-4 col-12 p-1">
                <base-select :options="severitySelect.options" searchable :loading="severitySelect.loading" v-model="severitySelect.value" :label="$i18nHelpers.normalizeProp('name')" valueProp="id"></base-select>
            </div>
            <div class="col-lg-2 col-12 p-1">
                <base-button @click="save">{{ $t('save') }}</base-button>
            </div>
        </div>
        <paginated-table :fields="table.fields" :items="items" :empty-text="$t('noallergy')" :stacked="stacked">
            <template v-slot:cell(remove)="data" v-if="!historyReadOnly">
                <base-icon class="clickable" src="/static-appopensalud/img/icons/morillas-svg-icons/primary/remove.svg" @click.prevent="remove(data)" :color="RED_COLOUR"></base-icon>
                <span v-if="stacked" @click.prevent="remove(data)" class="clickable">{{$t('remove')}}</span>
                <hr v-if="stacked">
            </template>
        </paginated-table>
    </base-card>
</div>
</template>

<script>
import PaginatedTable from '@/components/base/PaginatedTable'
import ClinicHistoryRepository from '@/repositories/ClinicHistoryRepository'
import BaseSelect from '@/components/base/forms/BaseSelect'
import BaseButton from '@/components/base/buttons/BaseButton'
import AddButton from '@/components/base/buttons/AddButton'
import BaseCard from '@/components/base/ui/BaseCard.vue'
import { RED_COLOUR } from '@/constants/colours'
import clinicHistoryMixin from '@/mixins/clinicHistory.mixin'
import i18nMixin from '@/mixins/i18n.mixin'

const I18N_FILE = 'clinic-history'

export default {
    name: 'history-med-allergies-section',
    components: {
        PaginatedTable,
        BaseSelect,
        BaseButton,
        AddButton,
        BaseCard
    },
    props: {
        patientId: {
            type: String,
            required: false,
            default: null
        }
    },
    mixins: [clinicHistoryMixin, i18nMixin(I18N_FILE)],
    computed: {
        clinicHistoryRepository () {
            return ClinicHistoryRepository()
        },
        stacked () {
            return window.innerWidth < 500
        },
        showZeroBox () {
            return !this.items.length
        }
    },
    data () {
        return {
            items: [],
            showAddSection: false,
            zeroItems: null,
            table: {
                fields: [
                    {
                        label: this.$t('description-column'),
                        key: 'name'
                    },
                    {
                        label: this.$t('gravity-ph'),
                        key: 'severityName'
                    },
                    {
                        label: '',
                        key: 'remove'
                    }
                ],
                filters: {
                    specialtyId: null
                }
            },
            select: {
                options: [],
                value: null,
                loading: false
            },
            severitySelect: {
                options: [],
                value: null,
                loading: false
            },
            RED_COLOUR
        }
    },
    methods: {
        toggleZeroBox () {
            this.clinicHistoryRepository.saveHistoryMedAllergies({
                noMedsAllergies: this.zeroItems
            })
        },
        load () {
            this.severitySelect.loading = true
            this.clinicHistoryRepository.getHistoryMedAllergies().then((response) => {
                let data = response.data.data
                if (data.length && data[0].noMedsAllergies) {
                    this.zeroItems = true
                    return
                }
                this.items = data
            })
            this.clinicHistoryRepository.getSeverities().then((response) => {
                this.severitySelect.options = response.data.data
                this.severitySelect.loading = false
            })
        },
        loadSelectOptions (search) {
            if (search) {
                this.select.loading = true
                this.clinicHistoryRepository.getMedAllergiesByName(search).then((response) => {
                    this.select.options = response.data.data
                    this.select.loading = false
                })
            }
        },
        save () {
            if (!this.select.value) {
                this.$store.dispatch('showInfoAlert', this.$t('medicationSelectError'))
                return
            }
            if (!this.severitySelect.value) {
                this.$store.dispatch('showInfoAlert', this.$t('allergySeveritySelectError'))
                return
            }
            this.clinicHistoryRepository.saveHistoryMedAllergies({
                dcsa: this.select.value,
                severityId: this.severitySelect.value
            }).then(response => {
                let data = response.data
                if (data && data.status === 200) {
                    this.items.unshift(data.data)
                }
                this.select.value = null
                this.severitySelect.value = null
                this.select.options = []
            })
        },
        remove (data) {
            let id = data.item.id
            this.clinicHistoryRepository.deleteHistoryAllergy(id).then(response => {
                if (response.data.data) {
                    this.items = this.items.filter(item => item.id !== id)
                }
            })
        }
    },
    created () {
        this.load()
    }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/shared/HistoryMedAllergiesSection.vue